// Frame sizes shared by several dialogs. Sizes used by a single dialog stay in its own file.

export const CONFIRM_MODAL_WIDTH_MOBILE = 268;
export const CONFIRM_MODAL_WIDTH_TABLET = 541;
export const CONFIRM_MODAL_WIDTH_DESKTOP = 611;
export const CONFIRM_MODAL_HEIGHT_MOBILE = 192;
export const CONFIRM_MODAL_HEIGHT_DESKTOP = 216;

export const FORM_MODAL_WIDTH_MOBILE = 268;
export const FORM_MODAL_WIDTH_TABLET = 660;
export const FORM_MODAL_WIDTH_DESKTOP = 700;
export const FORM_MODAL_HEIGHT_MOBILE = 263;
export const FORM_MODAL_HEIGHT_DESKTOP = 272;

export const NOTIFICATION_MODAL_CLOSE_DELAY_MS = 2000;
